module.exports = __webpack_public_path__ + "img/4.5740c941.png";